import { motion } from 'framer-motion'
import { Building, GraduationCap, Users } from 'lucide-react'
import SidebarGalleryPage from '../Main/Sidebargallery'

const campusInfo = {
  description: "The College is spread over a sprawling four-acre campus with a well-ventilated building, hostel facility, sports ground, and more. The college building features spacious classrooms, a seminar hall, well-equipped laboratories, workshops, and a library, thus providing a conducive environment for teaching-learning.",
  features: [
    "Free Admission",
    "1000 /- incentives",
    "Equipped with modern equipment",
    "Free Books & Stationery",
    "Industrial Visits and Training",
    "Job Support & Guidance",
    "CCTV Surveillance",
    "Basketball Ground in Hostel"
  ]
}

export default function CampusSection() {
  return (
    <div className="min-h-screen bg-gray-100 p-6">
      {/* Main Content */}
      <div className="max-w-7xl mx-auto p-4 md:p-6 flex flex-col lg:flex-row gap-8">
        {/* Left Column - Campus Section */}
        <motion.div
          className="lg:w-2/3"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="space-y-6">
            {/* Section Header */}
            <div className="rounded-md">
              <div className="border-4 border-[#00BFA5] rounded-md p-2">
              <h2 className="text-xl font-bold mb-4 flex items-center gap-2  bg-[#00BFA5] text-white rounded-sm w-full p-4">
                <Building className="w-6 h-6" />
                College Campus
              </h2>
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
                className="leading-relaxed p-2"
              >
                {campusInfo.description}
              </motion.p>

              {/* Campus Features */}
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3 }}
              >
                <h3 className="font-semibold text-[#00BFA5] p-2">Campus Highlights:</h3>
                <div className="grid grid-cols-2 gap-3 md:grid-cols-3 p-2">
                  {campusInfo.features.map((feature, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.4 + index * 0.1 }}
                      className="flex items-center gap-2"
                    >
                      <GraduationCap className="w-4 h-4 text-[#00BFA5]" />
                      <span>{feature}</span>
                    </motion.div>
                  ))}
                </div>
              </motion.div>

              </div>
              {/* Virtual Campus Tour Section */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.8 }}
                className="mt-4 p-4 rounded-lg border-[#00BFA5] border-4"
              >
                <div className="flex items-center gap-2 text-lg font-semibold text-[#00BFA5]">
                  <Users className="w-5 h-5" />
                  Virtual Campus Tour
                </div>
                <p className="mt-2 text-sm">
                  Experience our campus virtually! Take a tour of our state-of-the-art facilities and modern infrastructure.
                </p>
              </motion.div>
            </div>
          </div>
        </motion.div>

        {/* Right Column - Gallery */}
        <SidebarGalleryPage />
      </div>
    </div>
  )
}
